<template>
    <div class="table-action-cell" :class="grid">
        <!-- PremadeMode: you can just add icon and label -->
        <button @click="callback" v-if="!noPremadeMode">
            <div class="table-action-cell__icon-wrapper">
                <slot></slot>
            </div>
            <div class="table-action-cell__label">{{label}}</div>
        </button>
        <!-- noPremadeMode: If you have more complicate action button, which will be reactived with your callback function,
        i.e. lock function of user, use this -->
        <button @click="callback" v-if="noPremadeMode">
            <slot></slot>
        </button>
    </div>
</template>

<script>
    export default {
        props: {
            'callback':'',
            'label':'',
            'noPremadeMode':'',
            'grid':{
                default: 'table-action-cell--grid-1of3'
            }
        },
    }
</script>
